import { PropsWithChildren, ReactElement, useMemo } from "react";
import { useListFrontlineAppConfigHandlerPtFrontlineAppConfigGetQuery as useListFrontlineConfig } from "oneclick-component/src/store/apis/enhancedApi";
import LoadingScreen from "oneclick-component/src/components/LoadingScreen";
import {
  FeatureConfigContext,
  FeatureConfigContextValue,
} from "./FeatureConfigContext";

const FALLBACK_FEATURE_CONFIG_CONTEXT_VALUE: FeatureConfigContextValue = {
  shouldShowCancelApplyFeature: false,
  enableCcoRole: false,
};

const FeatureConfigProvider = (props: PropsWithChildren): ReactElement => {
  const { data, isLoading } = useListFrontlineConfig();

  const contextValue = useMemo(() => {
    if (data == null) {
      return FALLBACK_FEATURE_CONFIG_CONTEXT_VALUE;
    }
    return { ...data };
  }, [data]);

  if (isLoading) {
    return <LoadingScreen />;
  }
  return (
    <FeatureConfigContext.Provider value={contextValue}>
      {props.children}
    </FeatureConfigContext.Provider>
  );
};

export default FeatureConfigProvider;
